import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d8e239d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "Import des nouveaux codes", -1))

import ProductStockImport from "@/components/product/stock/ProductStockImport.vue"
import CustomButton from "@/components/forms/CustomButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CodeCreate',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: { name: 'ListCodes' },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createVNode(ProductStockImport, {
      importType: "code",
      importRoute: "product_code_imports"
    })
  ], 64))
}
}

})